<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">
                <ng-container *ngIf="product?.id; else titleAddProduct">
                    {{ 'dialogs.getProductFee.titleEdit' | translate }}
                </ng-container>
                <ng-template #titleAddProduct>
                    {{ 'dialogs.getProductFee.titleAdd' | translate }}
                </ng-template>
            </h2>
            <button data-test="B-Close-dialog" mat-icon-button (click)="dialogRef.close(false)"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>

        <form [formGroup]="productForm" fxLayout="column">

            <ng-container *ngIf="products?.length; else noProducts">

                <div fxLayout="row" fxLayoutAlign="start start" class="mb-24">
                    <mat-form-field fxFlex appearance="outline">
                        <mat-label>{{ 'table.product' | translate }}</mat-label>
                        <input type="text" matInput data-test="FI-Produkte durchsuchen..."
                               formControlName="product" [placeholder]="'dialogs.productSubscription.productsSearchLabel' | translate"
                               [matAutocomplete]="productSelector">
                        <mat-hint *ngIf="selectedProduct as selected">
                            <bcm-product-price-label textAlign="left"></bcm-product-price-label>
                            : {{ selected.price | bcmDynamicCurrency: '1.2-2' }}
                            <ng-container *ngIf="getUnitLabel(selected.unit) as unitLabel"> / {{ unitLabel }}</ng-container>
                        </mat-hint>
                        <mat-error *ngIf="productForm.get('product').touched">{{ productForm.get('product').errors | firstErrorMessage }}</mat-error>
                    </mat-form-field>

                    <mat-autocomplete #productSelector="matAutocomplete"
                                      [displayWith]="displayProductWith"
                                      (optionSelected)="onProductSelected($event)">
                        <mat-option *ngFor="let product of (filteredProducts$ | async)"
                                    [value]="product"
                                    (mousedown)="$event.preventDefault()">
                            <span>{{ product?.name }}</span>
                            <small> | {{ product?.price | bcmDynamicCurrency :'1.2-4' }}</small>
                            <ng-container *ngIf="getUnitLabel(product?.unit) as unitLabel">
                                <small> / {{ unitLabel }}</small>
                            </ng-container>
                        </mat-option>
                    </mat-autocomplete>
                </div>

                <ng-container *ngIf="showQuantityField">
                    <div fxLayout="row" fxLayoutAlign="start start">
                        <mat-form-field fxFlex appearance="outline">
                            <mat-label>
                                <ng-container *ngIf="getUnitLabel(selectedProduct?.unit) as unitLabel; else genericQuantityLabel">
                                    {{ 'dialogs.getProductFee.quantityLabelWithUnit' | translate : { unit: unitLabel } }}
                                </ng-container>
                                <ng-template #genericQuantityLabel>{{ 'table.quantityUnits' | translate }}</ng-template>
                            </mat-label>
                            <app-input-number
                                    matInput
                                    data-test="FI-Anzahl / Einheiten"
                                    formControlName="quantity"></app-input-number>
                            <mat-hint *ngIf="getUnitLabel(selectedProduct?.unit) as unitLabel">
                                {{ 'dialogs.getProductFee.quantityUnitHint' | translate : { unit: unitLabel } }}
                            </mat-hint>
                            <mat-error>{{ productForm.get('quantity').errors | firstErrorMessage }}</mat-error>
                        </mat-form-field>
                    </div>

                    <div *ngIf="showSqmFixedQuantityHint" class="mb-16">
                        <mat-hint>{{ 'dialogs.getProduct.sqmFixedQuantityHint' | translate }}</mat-hint>
                    </div>
                </ng-container>

                <ng-container *ngIf="showBookingSettingsSection">
                    <mat-divider class="my-24"></mat-divider>
                    <h4 class="m-0 mb-16">{{ 'dialogs.getProductFee.bookingSettingsTitle' | translate }}</h4>

                    <ng-container *ngIf="showSkipStayDurationQuantityCheckbox">
                        <div fxFlex="100">
                            <mat-checkbox data-test="FCB-Menge nicht automatisch"
                                          formControlName="skipStayDurationQuantity">
                                {{ 'dialogs.getProductFee.skipStayDurationCheckbox' | translate }}
                            </mat-checkbox>
                        </div>
                        <u2b-message type="info" class="mt-16 mb-16" [collapsable]="true">
                            <header>{{ 'dialogs.getProductFee.skipStayDurationHelpTitle' | translate }}</header>
                            <p>{{ 'dialogs.getProductFee.skipStayDurationHelpP1' | translate }}</p>
                            <p>{{ 'dialogs.getProductFee.skipStayDurationHelpP2' | translate }}</p>
                        </u2b-message>
                    </ng-container>

                    <ng-container *ngIf="showIgnoreFreeOfChargePositionCheckbox">
                        <div fxFlex="100">
                            <mat-checkbox data-test="FCB-Position erstellen wenn Preis"
                                          formControlName="ignoreFreeOfChargePosition">
                                <span [innerHTML]="'dialogs.getProductFee.ignoreZeroPositionCheckbox' | translate : { zero: (0 | bcmDynamicCurrency) }"></span>
                            </mat-checkbox>
                        </div>
                        <u2b-message type="info" class="mt-16" [collapsable]="true">
                            <header>{{ 'dialogs.getProductFee.ignoreZeroHelpTitle' | translate }}</header>
                            <p [innerHTML]="'dialogs.getProductFee.ignoreZeroHelpP1' | translate : { zero: (0 | bcmDynamicCurrency) }"></p>
                            <p [innerHTML]="'dialogs.getProductFee.ignoreZeroHelpP2' | translate : { zero: (0 | bcmDynamicCurrency) }"></p>
                            <p [innerHTML]="'dialogs.getProductFee.ignoreZeroHelpP3' | translate : { zero: (0 | bcmDynamicCurrency), boat: ('boats.singular' | translate) }"></p>
                        </u2b-message>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="data.hasTenantRelationSelection">
                    <mat-divider class="my-24"></mat-divider>
                    <u2b-message type="info" class="mt-16" [collapsable]="true">
                        <header>{{ 'dialogs.getProductFee.tenantRelationWhyTitle' | translate }}</header>
                        <p>{{ 'dialogs.getProductFee.tenantRelationWhyBody' | translate }}</p>
                    </u2b-message>
                    <form-widget-tenant-relation [selectedTenantRelations]="product?.forTenantRelations"
                                                 [disableConditionCallback]="tenantRelationDisableConditionCallback"
                                                 [tenantRelationRequired]="false"
                                                 [slimmedView]="true"
                                                 [tenantRelationRequired]="false"
                                                 [multipleSelectable]="true"></form-widget-tenant-relation>
                </ng-container>
            </ng-container>

            <ng-template #noProducts>
                {{ 'dialogs.productSubscription.noProductsFound' | translate }}
            </ng-template>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">
        <button data-test="B-Abbrechen" mat-button
                (click)="dialogRef.close(false)"
                [attr.aria-label]="'common.closeDialogAria' | translate">
            <mat-icon>cancel</mat-icon>
            {{ 'common.cancel' | translate }}
        </button>

        <button data-test="B-Speichern" mat-flat-button
                color="accent"
                (click)="saveAndContinue()"
                class="save-button"
                [disabled]="isSaving || !productForm.dirty"
                [attr.aria-label]="'common.save' | translate">
            {{ 'common.save' | translate }}
        </button>
    </div>
</div>
